import React from 'react';
import { Space, Popover } from 'antd';
import ToggleIcon from '@icons/common/toggle.svg';
import Toggles from './Toggles';
import Panels from './Panels';
import { MiddleSection } from './styled';
import LatchSave from '../LatchSave';
import { ToggleButton } from '@src/components/common/Utils/Buttons';

const Content = ({ optionRender }) => {
  return (
    <Space direction="vertical">
      <Space direction="horizontal" style={{ alignItems: 'flex-start' }}>
        <div>
          <Panels />
        </div>
        <MiddleSection>
          <Toggles />
        </MiddleSection>
        <div>
          {optionRender}
        </div>
      </Space>
    </Space>
  )
}


function OptionsPopover({ optionRender, pageKeyForSaveService, savingState }) {

  return (
    <Space wrap style={{ marginLeft: 10 }}>
      <LatchSave pageKeyForSaveService={pageKeyForSaveService} savingState={savingState} />
      <Popover
        content={<Content optionRender={optionRender} />}
        title=""
        trigger="click"
        placement="topRight"
        overlayInnerStyle={{ paddingLeft: 20 }}
        zIndex={900}
      >
        <ToggleButton icon={<ToggleIcon />} />
      </Popover>
    </Space>
  )
}

export default OptionsPopover;
